// @flow
import Spinner from 'components/Spinner'
import { useLoadBilling } from 'queries/payments/useLoadBilling'
import * as React from 'react'
import Flex from 'ui/atoms/Flex'
import FlexBox from 'ui/atoms/FlexBox'
import Modal from 'ui/atoms/Modal'
import Table from 'ui/atoms/Table'
import Text from 'ui/atoms/Text'

import UpdatePlan from '../UpdatePlan.jsx'
import CurrentPlanDetails from './CurrentPlanDetails.jsx'

function CurrentPlan(): React.Node {
  const { data: billing, isLoading: isBillingLoading } = useLoadBilling()
  const [showUpdatePlanModal, setShowUpdatePlanModal] = React.useState(false)
  const [showPlanDetails, setShowPlanDetails] = React.useState(false)

  const resource = billing?.subscription?.plan || billing?.subscription?.product

  const formattedBillingCycle = React.useMemo(() => {
    const interval = resource?.interval || resource?.prices?.[0]?.interval
    if (!interval) return ''
    if (interval === 'year') return 'Yearly'
    return 'Monthly'
  }, [resource?.interval, resource?.prices])

  return (
    <>
      <FlexBox className="max-w-2xl">
        <Table.Title>
          <Flex align="center" className="w-full" justify="between">
            <Text>Current Plan Summary</Text>
          </Flex>
        </Table.Title>
        <Table>
          <Table.Head
            columns={['PLAN NAME', 'BILLING CYCLE']} // , 'SUBSCRIPTION']}
          />
          <Table.Body>
            {isBillingLoading || !resource ? (
              <Table.Row>
                <Table.Column>
                  {isBillingLoading ? (
                    <Spinner color="onLight" />
                  ) : (
                    <Text>You haven't chosen a plan yet.</Text>
                  )}
                </Table.Column>
                <Table.Column />
                {/* <Table.Column /> */}
              </Table.Row>
            ) : (
              <Table.Row>
                <Table.Column>
                  <Text>{resource?.name}</Text>
                </Table.Column>
                <Table.Column>
                  <Text>{formattedBillingCycle}</Text>
                </Table.Column>
              </Table.Row>
            )}
          </Table.Body>
        </Table>
      </FlexBox>
      {showUpdatePlanModal && (
        <Modal show>
          <UpdatePlan onCancel={() => setShowUpdatePlanModal(false)} />
        </Modal>
      )}
      {showPlanDetails && (
        <CurrentPlanDetails
          onClose={() => setShowPlanDetails(false)}
          planId={resource?.id}
        />
      )}
    </>
  )
}

export default CurrentPlan
